import { Icon } from "@equinor/e-procurement-portal-and-ts-portal-front-end-components";
import { mdiChevronDown, mdiChevronUp, mdiPencil } from "@mdi/js";
import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { HybridRouteListItemButtonLink } from "../HybridRouteListItemButtonLink";
import type { MenuWithSubmenu } from "./Menu";

export const ManualOperationsMenu: React.FC<MenuWithSubmenu> = memo(
  ({ handleClick, leftMenuOpen, openSubmenu, user }) => {
    const { t } = useTranslation();

    if (
      !(
        user.roles_names.includes("Delivery Date Change Request - List") ||
        user.roles_names.includes("View Manual Urgencies") ||
        user.roles_names.includes("Edit Manual Urgencies") ||
        user.vendor
      )
    ) {
      return null;
    }

    return (
      <>
        <ListItemButton
          // name="manualOperations"
          onClick={() => handleClick("manualOperations")}
          title={t("menu.manualOperations.title")}
        >
          <ListItemIcon sx={{ minWidth: "2rem" }}>
            <Icon icon={mdiPencil} />
          </ListItemIcon>
          {!!leftMenuOpen && (
            <ListItemText
              primary={t("menu.manualOperations.title")}
              slotProps={{
                primary: {
                  sx: {
                    fontSize: 14,
                  },
                },
              }}
              sx={{ whiteSpace: "normal" }}
            />
          )}
          <Icon
            icon={openSubmenu.manualOperations ? mdiChevronUp : mdiChevronDown}
          />
        </ListItemButton>
        <Collapse
          in={openSubmenu.manualOperations}
          timeout="auto"
          unmountOnExit
        >
          <List component="div" disablePadding>
            {user.roles_names.includes(
              "Delivery Date Change Request - List",
            ) && (
              <HybridRouteListItemButtonLink
                caption="manual operations delivery date change requests"
                name="manualOperations[deliveryDateChangeRequests]"
                sx={{ pl: 4 }}
                title={t(
                  "menu.manualOperations.submenu.deliveryDateChangeRequests.title",
                )}
                url="/delivery_date_change_requests"
              >
                <ListItemText
                  primary={t(
                    "menu.manualOperations.submenu.deliveryDateChangeRequests.title",
                  )}
                  slotProps={{
                    primary: { sx: { fontSize: 14 } },
                  }}
                  sx={{ whiteSpace: "normal" }}
                />
              </HybridRouteListItemButtonLink>
            )}

            {user.equinor &&
              user.roles_names.includes(
                "Delivery Date Change Request - List",
              ) && (
                <HybridRouteListItemButtonLink
                  caption="manual operations expediting"
                  isReact={false}
                  name="manualOperations[expediting]"
                  sx={{ pl: 4 }}
                  title={t("menu.manualOperations.submenu.expediting.title")}
                  url="/vbuyer/expeditings/follow_up"
                >
                  <ListItemText
                    primary={t(
                      "menu.manualOperations.submenu.expediting.title",
                    )}
                    slotProps={{
                      primary: { sx: { fontSize: 14 } },
                    }}
                    sx={{ whiteSpace: "normal" }}
                  />
                </HybridRouteListItemButtonLink>
              )}

            {(user.roles_names.includes("View Manual Urgencies") ||
              user.roles_names.includes("Edit Manual Urgencies")) && (
              <HybridRouteListItemButtonLink
                caption="manual operations change urgencies"
                isReact={false}
                name="manualOperations[changeUrgencies]"
                sx={{ pl: 4 }}
                title={t("menu.manualOperations.submenu.changeUrgencies.title")}
                url="/vbuyer/manual_operation_urgencies"
              >
                <ListItemText
                  primary={t(
                    "menu.manualOperations.submenu.changeUrgencies.title",
                  )}
                  slotProps={{
                    primary: { sx: { fontSize: 14 } },
                  }}
                  sx={{ whiteSpace: "normal" }}
                />
              </HybridRouteListItemButtonLink>
            )}
          </List>
        </Collapse>
      </>
    );
  },
);
